export enum DrainsAndTubesConstants {
  SET_NG_TUBE = 'drainsAndTubes/SET_NG_TUBE',
  SET_NG_TUBE_SUCTION = 'drainsAndTubes/SET_NG_TUBE_SUCTION',
  SET_OG_TUBE = 'drainsAndTubes/SET_OG_TUBE',
  SET_OG_TUBE_SUCTION = 'drainsAndTubes/SET_OG_TUBE_SUCTION',
  SET_CHEST_TUBE_L = 'drainsAndTubes/SET_CHEST_TUBE_L',
  SET_CHEST_TUBE_L_SUCTION = 'drainsAndTubes/SET_CHEST_TUBE_L_SUCTION',
  SET_CHEST_TUBE_R = 'drainsAndTubes/SET_CHEST_TUBE_R',
  SET_CHEST_TUBE_R_SUCTION = 'drainsAndTubes/SET_CHEST_TUBE_R_SUCTION',
  SET_FOLEY = 'drainsAndTubes/SET_FOLEY',
  SET_FOLEY_COLOR = 'drainsAndTubes/SET_FOLEY_COLOR',
  SET_PEG_TUBE = 'drainsAndTubes/SET_PEG_TUBE',
  SET_PEG_TUBE_CAPPED = 'drainsAndTubes/SET_PEG_TUBE_CAPPED',
  SET_ILEOSTOMY = 'drainsAndTubes/SET_ILEOSTOMY',
  SET_COLOSTOMY = 'drainsAndTubes/SET_COLOSTOMY',
  SET_VENTRICULOSTOMY = 'drainsAndTubes/SET_VENTRICULOSTOMY',
  SET_CSF_COLOR = 'drainsAndTubes/SET_CSF_COLOR',
  SET_COMMENTS_OTHER = 'drainsAndTubes/SET_COMMENTS_OTHER',
  SAVE_DRAINS_AND_TUBES = 'drainsAndTubes/SAVE_DRAINS_AND_TUBES',
  SET_DRAINS_AND_TUBES = 'drainsAndTubes/SET_DRAINS_AND_TUBES',
  RESET_DRAINS_AND_TUBES = 'drainsAndTubes/RESET_DRAINS_AND_TUBES',
}
